"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushNotificationIdentity = void 0;
var PushNotificationIdentity;
(function (PushNotificationIdentity) {
    PushNotificationIdentity["Moment"] = "moment";
    PushNotificationIdentity["Exercise"] = "exercise";
    PushNotificationIdentity["FirstMeeting"] = "first-meeting";
    PushNotificationIdentity["NoFirstMeeting"] = "no-first-meeting";
    PushNotificationIdentity["WelcomeAfterSuccessfulPayment"] = "welcome-after-successful-payment";
    PushNotificationIdentity["RegularChatMessage"] = "regular-chat-message";
    PushNotificationIdentity["SegmentForumMention"] = "segment-forum-mention";
    PushNotificationIdentity["NotSpecified"] = "not-specified";
})(PushNotificationIdentity = exports.PushNotificationIdentity || (exports.PushNotificationIdentity = {}));
//# sourceMappingURL=pushNotification.js.map